import { BlockProps } from './types';
import { IncreaseHighBid } from '../../containers';
import { BID_INCREMENT, BUYER_VEHICLE_STATUS, VEHICLE_STATUSES } from '../../../../../constants';
import { useSelector } from 'react-redux';
import { getMinBitAmount } from '../../../../../utils/vehicle';
import { auctionOfferStatuses } from 'utils/statusCalculator';

type Props = BlockProps;

export const RenderPlaceAlternativeBid = ({ currentVehicle }: Props) => {
  const user = useSelector((state: any) => state.user?.user);

  const minBidAmount = getMinBitAmount(currentVehicle, user);
  const activeOffer = currentVehicle.active_alternative_offer;

  const status = auctionOfferStatuses(currentVehicle, null, user);

  const canPlaceBid =
    user?.role === 'buyer' &&
    currentVehicle.status === VEHICLE_STATUSES.ACTIVE &&
    [BUYER_VEHICLE_STATUS.ACTIVE_ALTERNATIVE_AUCTION, BUYER_VEHICLE_STATUS.ALTERNATIVE_UNDECIDED_WITH_OFFER].includes(
      status
    );
  if (!canPlaceBid) return null;

  return (
    <IncreaseHighBid
      isSidePanelBid
      variant={'alternative_offer'}
      form={`biddingForm_${currentVehicle.id}`}
      vehicleId={currentVehicle.id}
      minAmount={minBidAmount}
      bidIncrement={BID_INCREMENT}
      type={'alternative_offer'}
    />
  );
};
